{
	"accountMigrated": "This account has been migrated. Please continue on",
	"noPermission": "Your account doesn't have permission to access Photo Editor",
	"pendingApproval": "Your account ({{email}}) is pending approval by the Polarr Team."
}
